import classNames from 'classnames';
import React from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';
import TopicNameWithIcon from './TopicNameWithIcon';
import * as styles from './TopicSelectHierarchicalOption.module.scss';
import TopicSelectOption from './TopicSelectOption';
import type { TopicHierarchicalOptionType } from './useTopicHierarchicalSelectProps';
import Tooltip from '../components/Tooltip';

type TopicSelectHierarchicalOptionProps =
  OptionProps<TopicHierarchicalOptionType>;

const TopicSelectHierarchicalOption = (
  props: TopicSelectHierarchicalOptionProps,
) => {
  const {
    isDisabled,
    data: {
      __isNew__: isNew,
      __isLimited__: isLimited,
      topic,
      matches,
      secondary,
      tooltip,
    },
    selectProps: { inputValue },
  } = props;

  let content = null;

  if (isNew) {
    content = (
      <div className={classNames(styles.uiElement, styles.isNew)}>
        {props.children}
      </div>
    );
  } else if (isLimited) {
    content = (
      <div className={styles.uiElement}>Start typing to see more results…</div>
    );
  } else if (topic) {
    content = inputValue ? (
      <TopicSelectOption
        disabled={isDisabled}
        hideIcon
        matches={matches}
        secondary={secondary}
        topic={topic}
      />
    ) : (
      <div className={styles.topic}>
        {(topic.ancestors || []).map(({ id }) => (
          <div key={id} className={styles.childLine} />
        ))}
        <div className={styles.text}>
          <TopicNameWithIcon topic={topic} />
        </div>
      </div>
    );
  }

  return (
    <div
      className={classNames({
        [styles.disabled]: isDisabled,
        [styles.limited]: isLimited,
      })}
    >
      <components.Option className={styles.option} {...props}>
        {tooltip ? (
          <Tooltip display="block" content={tooltip}>
            {content}
          </Tooltip>
        ) : (
          content
        )}
      </components.Option>
    </div>
  );
};

export default TopicSelectHierarchicalOption;
